export default __webpack_public_path__ + "static/media/phone.3cded2f5.svg";